import { manifests as UmbIsRoutableContextConditionManifests } from './conditions/is-routable-context/manifests.js';

export const manifests: Array<UmbExtensionManifest> = [...UmbIsRoutableContextConditionManifests];
